<template>
    <div class="flex flex-wrap gap-4">
        <Popover v-for="cat in promotedCategories" :key="'promo-cat-' + cat.name">
            <PopoverTrigger :value="'promo-cat-' + cat.name">
                <div
                    class="border-1 rounded-xl hover:bg-white transition-all cursor-pointer hover:text-primary px-4 py-2 flex gap-2 items-center justify-between">
                    <div class="text-nowrap">{{ cat.name }}</div>
                    <div class="text-xs" v-if="cat.minPrice">
                        {{ $t('Fra') }}
                        {{ priceFormat(cat.minPrice)}}
                    </div>
                    <Plus :strokeWidth="1" :size="18" />
                </div>
            </PopoverTrigger>
            <PopoverContent class="p-1 rounded-xl mt-1 border-1 border-zinc-200">
                <div v-for="item in cat.products"
                     class="cursor-pointer border-1 border-white hover:text-white hover:bg-primary rounded-xl px-4 py-2"
                     :key="'promo-cat-item-' + item.id"
                     @click="select(cat, item)">
                    {{ item.product_name_on_web || item.product_name }}
                </div>
            </PopoverContent>
        </Popover>

        <div v-show="showCalendar" class="fixed z-51 top-0 left-0 min-h-screen p-8 bg-primary space-y-4 grid grid-cols-1 items-center">
            <div class="space-y-8">
                <div class="flex justify-between">
                    <h2 class="text-4xl">{{ $t('Bookingkalender') }}</h2>
                    <X @click="closeCalendar"/>
                </div>
                <div class="bg-white p-8 rounded-xl text-black">
                    <Calendar></Calendar>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
    import { ref } from 'vue'
    import axios from 'axios'
    import {
        Popover,
        PopoverContent,
        PopoverTrigger,
    } from '@/components/ui/popover'
    import { useCalendarStore } from './CalendarStore'
    import Calendar from './Calendar.vue'

    import {Plus, X} from "lucide-vue-next"

    const calendarStore = useCalendarStore();
    const emits = defineEmits(['select'])

    const showCalendar = ref(false);

    function select(category, product) {
        calendarStore.currentCategory = category.id;
        calendarStore.currentProduct = product;
        emits('select', { categoryId: category.id, productId: product.id})
        showCalendar.value = true
    }

    function closeCalendar() {
        showCalendar.value = false
    }

    function priceFormat(price) {
        return price ? window.TABS.L10n.money.parse(price).format() : '';
    }

    const promotedCategories = ref( window.homePageData.promotedCategories || []);

    if (promotedCategories.value.length === 0) {
        // No promoted categories set, run api call to fetch them
        axios.get('/api/v2/promoted-categories?officeId=' + window.officeId).then(response => {
            promotedCategories.value = response.data.categories || [];
        })
    }
</script>